import { TrackingEnv } from '@app/core/services/tracking/tracking.env';
import { AppType, IEnvironment } from './environment.interface';

export const environment: IEnvironment = {
  production: false,
  ciamAPIUrl:
    'https://prd-weu1-rc-df-ciam-api-webservice-stg.cloud-effem.com/lifecycle',
  apimAPIUrl: 'https://rc-api.staging.royalcanin.com/ciam',
  contactUsApiUrl:
    'https://rc-api.staging.royalcanin.com/internal/myaccount/contactus',
  myAccountBffUrl: 'https://prd-weu1-rc-df-myaccount-bff-stg.cloud-effem.com',
  OcpApimSubscriptionKey: '7e62548b9dc945c6a9a389fe24a776ef',
  globalRedirectUri: 'https://royalcanin.com',
  trackingEnv: TrackingEnv.staging,
  environmentName: 'stg',
  okta: {
    domain: 'accountpreview.royalcanin.com',
    clientId: '0oasfmhh35rrnqXvf0x6',
    socialIdp: {
      facebook: '0oarsmtlhd1q9NyPb0x6',
      google: '0oarsoyvckBINudT70x6',
      paypal: '0oa4kynyl26Xg5Zqx0x7',
      apple: '0oa49408qyud6h9eG0x7',
      kakao: '0oa5im4am9hKzU0ga0x7',
    },
  },
  appType: AppType.RC,
  isWhiteLabel: false,
  gdpRedirectURI: 'https://signin-stg.gdp.royalcanin.com',
};
